/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:41:58
 * @Description: file content
 */ 
import React, { Component } from 'react';
//import OriginCalendar from 'bee-calendar';
import { Calendar as OriginCalendar } from "@tinper/next-ui";

//require('bee-calendar/build/Calendar.css');

class Calendar extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <OriginCalendar {...this.props} />;
	}
}
export default Calendar;